.ux-tooltip {
  height: 0;
  overflow: visible;
  width: 0;

  *[data-ux-tooltip-close] {
    cursor: pointer;
  }

  // switched to here as display for tooltip was overwritten in _pre-hydration file
  &.hydrated {
    display: block;
  }

  &__tip {
    background-color: $color-white;
    box-shadow: -2px 0 22px 2px rgba(19, 19, 19, 0.08);
    height: auto;
    overflow: visible;
    padding: 30px 10px 30px 30px;
    position: fixed;
    text-align: left;
    visibility: hidden;
    width: 300px;
    z-index: $z-index-tooltip;

    &--active {
      visibility: inherit;
    }

    &::after {
      border-color: $color-white transparent transparent;
      border-style: solid;
      border-width: 18px;
      content: "";
      left: 50%;
      margin-left: -18px;
      position: absolute;
      top: 100%;
      z-index: 1;
    }

    &::before {
      box-shadow: 0 10px 15px 0.6px rgba(0, 0, 0, 0.3);
      content: "";
      height: 15px;
      left: 50%;
      position: absolute;
      top: 100%;
      width: 2px;
      z-index: -1;
    }
  }

  &__tip > * {
    padding-right: 20px;
  }

  &__tip--right {
    transform: translateY(-50%);

    &::after {
      border-color: transparent $color-white transparent transparent;
      left: -30px;
      top: 50%;
      transform: translate(50%, -50%);
    }

    &::before {
      box-shadow: -10px 5px 15px 0.6px rgba(0, 0, 0, 0.3);
      height: 2px;
      left: -20px;
      top: 50%;
      transform: translate(50%, -50%);
      width: 15px;
    }
  }

  &__tip--left {
    transform: translate(-100%, -50%);

    &::after {
      border-color: transparent transparent transparent $color-white;
      left: 100%;
      top: 50%;
      transform: translate(50%, -50%);
    }

    &::before {
      box-shadow: 5px 5px 15px 0.6px rgba(0, 0, 0, 0.3);
      height: 2px;
      left: 100%;
      top: 50%;
      width: 15px;
    }
  }

  &__tip--top {
    transform: translate(-50%, -100%);

    &::before {
      bottom: 0;
    }

    &::after {
      bottom: 0;
    }
  }

  &__tip--bottom {
    transform: translateX(-50%);

    &::after {
      border-color: transparent transparent $color-white transparent;
      top: -30px;
    }

    &::before {
      box-shadow: 0 -10px 15px 0.6px rgba(0, 0, 0, 0.3);
      top: -5px;
    }
  }
}
